import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import listensToClickOutside from 'react-onclickoutside';
import './style.css';

class HeaderDropDown extends Component {
  constructor() {
    super();
    this.state = {
      isOpened: false,
    };
    this.handleToggleDropDown = this.handleToggleDropDown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleToggleDropDown() {
    this.setState({
      isOpened: !this.state.isOpened,
    });
  }

  handleClickOutside() {
    this.setState({
      isOpened: false,
    });
  }

  render() {
    const {
      title,
      children,
      upCaret,
      upCaretCls,
      downCaret,
      downCaretCls,
      dropdownToggleClassName,
      isDropdownToggleAnimative,
    } = this.props;
    const dropdownClass = classNames({
      dropdown: true,
      open: this.state.isOpened,
    });
    const caretClass = classNames({
      'header__dropdown-icon': true,
      'header__dropdown-icon--active': isDropdownToggleAnimative && this.state.isOpened,
    });

    return (
      <li
        className={dropdownClass}
        onClick={this.handleToggleDropDown}
      >
        <a className={`dropdown-toggle header__dropdown-toggle ${dropdownToggleClassName}`}>
          {title}
          {upCaret && <i className={classNames(caretClass, upCaretCls)}/>}
          {downCaret && <i className={classNames(caretClass, downCaretCls)}/>}
        </a>
        <ul className="dropdown-menu header__dropdown-menu">
          {children}
        </ul>
      </li>
    );
  }
}

HeaderDropDown.propTypes = {
  children: PropTypes.array.isRequired,
  title: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.object,
  ]),
  upCaret: PropTypes.bool,
  upCaretCls: PropTypes.string,
  downCaret: PropTypes.bool,
  downCaretCls: PropTypes.string,
  dropdownToggleClassName: PropTypes.string,
  isDropdownToggleAnimative: PropTypes.bool,
};

HeaderDropDown.defaultProps = {
  dropdownToggleClassName: '',
  upCaretCls: 'fa fa-angle-up',
  downCaretCls: 'fa fa-angle-down',
  isDropdownToggleAnimative: true,
  companyStyle: {
    color: '#fff',
    background: '#008bcd',
  },
};

export default listensToClickOutside(HeaderDropDown);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/components/Header/components/HeaderDropDown/index.js
 **/